import { convertBezierJSToSequentialPoints, convertKnotToSequentialPoints } from './BezierHelper';
import { ChangeKnotPointToAbsolute } from './KnotHelper';
import ScaleHelper from './ScaleHelper';

export default class SVGHelper {
  static createSVGPathsFromBezierJS(beziers, scale = 1) {
    return beziers.map((bezier) => {
      const scaledBezier = ScaleHelper.scaleBezier(bezier, scale);
      const { x, y } = scaledBezier.points[0];

      return `M ${x} ${y} C ${convertBezierJSToSequentialPoints(scaledBezier, true)}`;
    });
  }

  static createSVGPathFromBezierJS(beziers) {
    const firstPoint = beziers[0].points[0];
    const moveCommand = `M ${firstPoint.x} ${firstPoint.y} `;
    let curveCommand = 'C ';
    for (let i = 0; i < beziers.length; i += 1) {
      if (i > 0) { curveCommand += ', '; }
      curveCommand += convertBezierJSToSequentialPoints(beziers[i], true);
    }

    return `${moveCommand} ${curveCommand}`;
  }

  static createSVGPath(knots, isClosed) {
    if (knots.length < 2) {
      return null;
    }

    const firstPoint = ChangeKnotPointToAbsolute(knots[0]);
    const moveCommand = `M ${firstPoint.x} ${firstPoint.y} `;
    let curveCommand = 'C ';
    for (let i = 0; i < knots.length - 1; i += 1) {
      if (i > 0) { curveCommand += ', '; }
      curveCommand += convertKnotToSequentialPoints(knots[i], knots[i + 1], true);
    }
    if (isClosed) {
      curveCommand += `, ${convertKnotToSequentialPoints(knots[knots.length - 1], knots[0], true)}`;
    }
    return `${moveCommand} ${curveCommand}`;
  }
}
